<template>
  <div id="proposta_passo0">

    <el-row>
      <el-col :span="24" class="proposta_titulo proposta_centro">Passo 1 - Proposta Comercial</el-col>
    </el-row>
   
      <el-row>
        <el-col :span="24">
                    <h1 class="proposta_titulo">Propostas Geradas para o orçamento número {{this.$route.params.id}}</h1>
        </el-col>
      </el-row>
          <el-row type="flex">
      <el-col :span="24" style="text-align:left; padding-bottom:10px;">

        <el-button
          style="margin-top: 12px;"
          type="primary"
          round
          size="medium"
          @click="novo"
          :disabled="disable_right"
        >
          Nova Proposta
          <i class="el-icon-tickets"></i>
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="itens"
          style="width: 100%"
          stripe
          id="tabela_propostas"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <el-table-column prop="id" label="Proposta" ></el-table-column>
          <el-table-column prop="status" label="Status" ></el-table-column>
          <el-table-column prop="data_proposta" label="Data da Proposta"></el-table-column>
          <el-table-column prop="acao" label="Ação" width="150px" filter-placement="bottom-end">
            <template slot-scope="scope" >
              <el-button-group>
                <el-tooltip  class="item" effect="light" content="Visualizar" placement="top">
                  <el-button
                    size="mini"
                    type="info"
                    @click="handleVisualizar(scope.$index, scope.row)"
                    icon="el-icon-notebook-2"
                  ></el-button>
                </el-tooltip>                
                <el-tooltip v-show="verifica(scope.row.status)" class="item"  effect="light" content="Editar"  placement="top">
                  <el-button 
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-document-copy"
                  ></el-button>
                </el-tooltip>                
                <el-tooltip class="item"  effect="light" content="Excluir" placement="top">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>      

    {{proposta_id}}
  </div>
</template>

<script>

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  props: {
    proposta_id: [Number],
  },
  data() {
    return {
      disable_left: true,
      disable_right: false,
      itens:[],

    };
  },
  mounted() {

this.getDados();
    
  },

  methods: {
    //EXCLUIR
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/proposta/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR 
   //LISTAR DADOS
    getDados() {
    
     axios
        .get(url + "/propostalista/"+this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if(!resp.data.status){
              this.itens = resp.data;
              
            }
            
           
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });

    },
    //FIM LISTAR DADOS

    handleEdit(index, row){
      let prop;
      prop = row.id;

      let dado = {
        active: 1,
        proposta: prop,
      };
      this.$emit("button-click", dado);      
    },
    handleVisualizar(index, row){
      let prop;
      prop = row.id;

      let dado = {
        active: 4,
        proposta: prop,
      };
      this.$emit("button-click", dado);      
    },

    novo() {
      let prop;
      prop = 0;

      let dado = {
        active: 1,
        proposta: prop,
      };
      this.$emit("button-click", dado);
    },
    verifica(status){
      if(status=='Concluído'){
        return false;
      } else{
        return true;
      }
    }
  },
};
</script>

<style>
#proposta_passo0 #proposta {
  height: 200px;
  width: 100%;
}
.proposta_titulo {
  text-align: left;
  font-weight: bold;
}
.proposta_centro {
  text-align: center;
}
#proposta_passo0 #tabela_propostas tr td{
  padding:0px;
}
#proposta_passo0 #tabela_propostas tr td .cell{
  padding:0px;
  margin-bottom: 0px;
  height: 34px;
  margin-top:5px;
}
#proposta_passo0 #tabela_propostas  {
  width:500px!important;
}

</style>